import { render } from "./mhafezjan50.vue?vue&type=template&id=785fd7cd"
import script from "./mhafezjan50.vue?vue&type=script&lang=js"
export * from "./mhafezjan50.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/teslaelectric-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__